import { BillingCycleStatus } from '../types/billing/billing-cycle-status';

export const PAYABLE_BILLING_CYCLE_STATUSES = [
  BillingCycleStatus.Payable,
  BillingCycleStatus.Overdue
];

export const AR_MX_PAYMENT_EXPIRATION_DAY_OF_MONTH = 11;

export const CONFIRMED_BILLING_STATUS_QUERY =
  'billingStatuses=billed,pre-billed';

export const PENDING_BILLING_STATUSES = ['provisioned'];
